import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box, Card, CardContent, CardMedia, Link, Paper, Button  } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Email, GitHub, LinkedIn, Work, FlightTakeoff, Psychology } from '@mui/icons-material';
// import { Email, GitHub, LinkedIn } from '@mui/icons-material';
// import PlaceIcon from '@mui/icons-material/Place';
import { useMediaQuery } from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import EastSharpIcon from '@mui/icons-material/EastSharp';
import { buttonStyles } from '../utils/utils';

const Profile: React.FC<{ isSidebarOpen: boolean; }> = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const theme = useTheme<Theme>(); // Get the theme and ensure it is of type Theme
  const isLargerThanSmall = useMediaQuery(theme.breakpoints.up('sm'));
  const isLargerThanMedium = useMediaQuery(theme.breakpoints.up('md'));
  const isLargerThanLarge = useMediaQuery(theme.breakpoints.up('lg'));
  const isLargerThanExtraLarge = useMediaQuery(theme.breakpoints.up('xl'));

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        // p: isLargerThanMedium ? 8 : 3,
        // pl: !isSidebarOpen ? 5 : (isLargerThanMedium ? 8 : 2),
        // p: isLargerThanSmall ? (isLargerThanLarge ? 14 : 10) : 6,
        p: 4,
        pb: 8,
        pl: isLargerThanSmall ? (isLargerThanLarge ? (isLargerThanExtraLarge ? 16 : 10) : 8) : (isSidebarOpen? 3: 5),
        pr: isLargerThanSmall ? (isLargerThanLarge ? (isLargerThanExtraLarge ? 18 : 10) : 8) : 3,
        backgroundColor: 'rgb(255, 253, 231, 0.6)',
        width: '100%',
        overflowY: 'auto',
      }}
    >
      <Typography variant="h2" component="h2" sx={{ mb: 6, mt: 2, textAlign: 'center' }}>
        Profile
      </Typography>
      {/* <Box sx={{ display: 'flex', justifyContent: 'right', mb: 5 }}>
        <div>
          <Button 
            sx={buttonStyles}
            variant="contained" color="primary" startIcon={<EastSharpIcon/>}
            onClick={() => handleNavigation('/education')}>
            Education
          </Button>
        </div>
      </Box> */}
    {/* <Box sx={{ display: 'flex', justifyContent: 'center', p: 3, backgroundColor: 'rgb(255, 253, 231, 0.9)', width: '100%', maxHeight:'500px' }}> */}
      <Card sx={{ width: '100%', bgcolor: 'rgb(255, 253, 231, 0.9)' }}>
        <Grid container spacing={2}>
          <Grid size={{ xs:12, sm: 12, md:6, lg:5, xl:4 }}>
            <CardMedia
              component="img"
              image="profile-photo-stand-crop2.jpeg"
              alt="Anjali Putta"
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
                border: '1px solid orange',
              }}
            />
          </Grid>
          <Grid
            size={{ xs: 12, sm: 12, md: 6, lg: 7, xl: 8 }}
            sx={{maxWidth: '780px'}}
          >
            <CardContent>
              <Typography gutterBottom variant="h4" component="div">
                Anjali Putta
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: '550' }}>
                Full Stack Developer @ American Express |
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: '550' }}>
                Building and deploying distributed systems for processing card payments into the American Express network.
              </Typography>
              {/* <Typography variant="body2" sx={{ fontWeight: '550' }}>
                Full Stack Developer @ Drone Response |
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: '550' }}>
                Building and deploying distributed systems for planning and executing complex drone missions
              </Typography> */}
              <Typography variant="body2" color="text.secondary" sx={{fontWeight: '550', mt: 4 }}>
                <Email sx={{ color: 'secondary.dark', verticalAlign: 'middle', mr: 1 }} />
                anjali54putta@gmail.com
              </Typography>
              {/* <Typography
                  variant="body2" color="text.secondary"
                  sx={{ fontWeight: '550' }}
                >
                <PlaceIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'secondary.dark' }} />Folsom, CA
              </Typography> */}
              <Typography variant="body2" sx={{fontWeight: '550' }}>
                <GitHub sx={{ color: 'secondary.dark', verticalAlign: 'middle', mr: 1 }} />
                <Link href="https://github.com/Anjali0407-git" target="_blank" rel="noopener">
                { isLargerThanMedium? 'https://github.com/Anjali0407-git': 'Anjali-Github'}
                </Link>
              </Typography>
              <Typography variant="body2" sx={{fontWeight: '550' }}>
                <LinkedIn sx={{ color: 'secondary.dark',verticalAlign: 'middle', mr: 1 }} />
                <Link href="https://www.linkedin.com/in/anjali-putta-278164227" target="_blank" rel="noopener">
                  { isLargerThanMedium? 'https://www.linkedin.com/in/anjali-putta-278164227/': 'Anjali-LinkedIn'}
                </Link>
              </Typography>
              <Typography variant="body2" sx={{fontWeight: '550' }}>
                <Psychology sx={{ color: 'secondary.dark',verticalAlign: 'middle', mr: 1 }} />
                <Link href="https://leetcode.com/u/AnjaliPutta/" target="_blank" rel="noopener">
                  { isLargerThanMedium? 'https://leetcode.com/u/AnjaliPutta/': 'Anjali-LeetCode'}
                </Link>
              </Typography>
              
              <Typography variant="body2"
                  color="text.secondary"
                sx={{ fontWeight: '550', mt: 2, px: isLargerThanLarge ? 4 : 0, py: 0.5, textAlign: 'justify' }}>
                I'm a results-driven Full Stack Developer with 5+ years of experience in building scalable and secure web applications using ASP.NET, C#, React, Angular, Next JS, Node.js, JS, TS, and Python.

                I specialize in designing high-performance systems that follow SOLID principles and clean architecture, ensuring code is maintainable, testable, and production-ready. My expertise includes managing CI/CD pipelines, and deploying and maintaining cloud-based solutions on AWS and Azure.

            Plus, I'm a big advocate for Agile practices—focusing on delivering iterative business value to customers and thriving in a collaborative environment..
                {/* I have a strong passion for full-stack development, specializing in .NET, JavaScript, Python and Java ecosystems.
                My experience extends to managing CI/CD pipelines as well as deploying, configuring, and maintaining cloud-based applications across major platforms like AWS, Azure, and GCP.
                I design scalable, secure, and high-performance systems, following SOLID principles to keep the code clean, testable, and easy to maintain.
                I have made a real impact in my projects and always aim to deliver my best work.
                Plus, I'm a big advocate for Agile practices—focusing on delivering iterative business value to customers and thriving in a collaborative environment. */}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: '550',mt: 2, textAlign: 'justify' }}>
                <Work sx={{ color: 'secondary.dark',verticalAlign: 'middle', mr: 1 }} />
                Currently seeking opportunities in Full Stack, Frontend, Backend, and Software Development.
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{fontWeight: '550' }}>
                <FlightTakeoff sx={{ color: 'secondary.dark',verticalAlign: 'middle', mr: 1 }} />
                Willing to relocate to any location.
              </Typography>

              {/* <Typography variant="body2" sx={{ fontWeight: '550', mt: 2, color: 'secondary.dark' }}>
                If you have relevant job opportunities or projects, please feel free to reach out to me at anjaliputta04@gmail.com.
              </Typography> */}

              <Paper
                // className="notched-paper"
                sx={{
                  mt: 6,
                  py: 2,
                  px: 1,
                  bgcolor: 'primary.light',
                  color: 'black',
                  borderRadius: 2,
                  boxShadow: '0 4px 4px rgba(0, 0, 0, 0.8)',
                  // boxShadow: 30,
                  textAlign: 'center',
                  // position: 'relative',
                  // overflow: 'visible',
                  // margin: 'auto',
                  // width: 'calc(100% - 80px)'
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: '600', display: 'block', textAlign: 'center' }}>
                  🌟 Open to Job Opportunities 🌟 <br />
                  If you have any relevant job offers, please feel free to contact me at{' '} 
                  <Link href="mailto:anjali54putta@gmail.com" color="inherit">
                    anjali54putta@gmail.com
                  </Link>.
                </Typography>
              </Paper>

            </CardContent>
          </Grid>
        </Grid>
      </Card>
      <Box sx={{ display: 'flex', justifyContent: 'right', mt: 10, mb: 2 }}>
        <div>
          <Button 
            sx={buttonStyles}
            variant="contained" color="primary" startIcon={<EastSharpIcon/>}
            onClick={() => handleNavigation('/education')}>
            Education
          </Button>
        </div>
      </Box>
      </Box>
      // </Box>
  );
}

export default Profile;
